import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Responses/Requests
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveEntityType } from './index';

// Api's
import { entityTypeApi } from '@/main/api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getEntityTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      entityTypeApi.getDomain
    );

    if (response.data.result) {
      yield put(saveEntityType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveEntityType(null, true, resultError.messagesDataError));
    }
  }
}
